import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import queryString from "query-string";

// Components
import { userState, lastSelectedPeriod, lastSelectedCategory } from "../../interface/MainInterface";
import SearchNavigation from "../aitb/articles/SearchNavigation";
import BriefList from "../aitb/articles/BriefList";

// CSS
import "./SearchResult.css";

interface propsType {
  userState: userState;
  briefList: any;
  setBriefList: any;
  searchText: string;
  setSearchText: any;
  selectedPeriod: string;
  setSelectedPeriod: any;
  lastEvalKey: any;
  setLastEvalKey: any;
  nowPageSize: number;
  setNowPageSize: any;
  lastScrollPos: number;
  setLastScrollPos: any;
  needRefresh: boolean;
  setNeedRefresh: any;
}

const SearchResult = (props: propsType) => {
  const location = useLocation();
  const queryParams: any = queryString.parse(location.search);
  const briefListRef: any = useRef();

  const [selectedCategory, setSelectedCategory] = useState<any>(null); // 선택한 카테고리

  useEffect(() => {
    if (!props.userState.isAuth) window.location.href = "/";

    // 사용자의 마지막 선택 카테고리를 세팅
    const cookieLastCategory: any = window.localStorage.getItem(lastSelectedCategory);
    if (cookieLastCategory !== undefined && cookieLastCategory !== "" && cookieLastCategory !== null) {
      setSelectedCategory(JSON.parse(cookieLastCategory));
    } else {
      setSelectedCategory(null);
    }
    return () => {
      setSelectedCategory(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section id="commWrap">
      <article className="article-01">
        <div className="article-tit ta-c">
          <span className="highlighter">"{queryParams.key}"</span>
          {` 키워드 검색 결과`}
          {/* <span className="highlighter">{`${resultCount}건`}</span> */}
        </div>
      </article>
      {queryParams.key !== undefined && queryParams.key !== null && queryParams.key !== "" && (
        <>
          <SearchNavigation
            selectedPeriod={props.selectedPeriod}
            selectedCategory={selectedCategory}
            callback={(payload: any) => {
              if (payload.command === "selected_period") {
                props.setSelectedPeriod(payload.value);
                window.localStorage.setItem(lastSelectedPeriod, payload.value);
              } else if (payload.command === "selected_category") {
                setSelectedCategory(payload.value);
                window.localStorage.setItem(lastSelectedCategory, JSON.stringify(payload.value));
              } else if (payload.command === "check_all") {
                briefListRef.current.checkAll(payload.value);
              }
            }}
          />
          <BriefList
            ref={briefListRef}
            userState={props.userState}
            selectedPeriod={props.selectedPeriod}
            selectedKeywords={[queryParams.key]}
            selectedCategory={selectedCategory}
            briefList={props.briefList}
            setBriefList={props.setBriefList}
            queryText={queryParams.key}
            searchText={props.searchText}
            setSearchText={props.setSearchText}
            lastEvalKey={props.lastEvalKey}
            setLastEvalKey={props.setLastEvalKey}
            nowPageSize={props.nowPageSize}
            setNowPageSize={props.setNowPageSize}
            lastScrollPos={props.lastScrollPos}
            setLastScrollPos={props.setLastScrollPos}
            needRefresh={props.needRefresh}
            setNeedRefresh={props.setNeedRefresh}
            callback={(payload: any) => {}}
          />
        </>
      )}
    </section>
  );
};

export default SearchResult;
